import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class AprovacaoCartaoPontoService {

    routePrefix: string = 'CartaoPonto'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(colaboradorId = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorColaboradorId?id=${colaboradorId}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    reprovar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Reprovar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    aprovar(id = ''): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Aprovar${this.routePrefix}?id=${id}`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarStatus(): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}Solicitacao/BuscarTudoStatusSolicitacao`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

}